/*
Run Element Plugin Instance Method

run jquery plugin instance methods on plugins.

### Html Attributes

```
  data-focus-within
  data-focus-within--classes="u-focus-within"
```

Styleguide Global.Javascript.AnchorElement
*/
import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

import { ELEMENT_SELECTOR, PLUGIN_NAME } from './index';

const log = debug(`plugins/${PLUGIN_NAME}`);

class PluginKlass {

  constructor(element, options) {
    log('construct', element, options);

    this.options = options;
    this.element = element;
    this.$element = $(element);

    this.watch();
  }

  watch () {

    this.$element.on('focusout', (event) => {
      log('focusout', event.target, event.relatedTarget);
      this.$element.removeClass(this.options.classes);
    });

    this.$element.on('focusin', (event) => {
      log('focusin', event.target, event.relatedTarget);
      this.$element.addClass(this.options.classes);
    });

  }

}

PluginKlass.DEFAULTS = {
  classes: 'u-focus-within',
};

export default PluginKlass;
//plugin(PLUGIN_NAME, PluginKlass);



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__focus-within/plugin.js